import { forwardRef, type Ref, type SVGProps } from "react";

function SvgThumbUpFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={0.857}
        d="M4.8 6.4h-.533C3.567 6.4 3 6.967 3 7.667v5.066C3 13.433 3.567 14 4.267 14h.533c.7 0 1.267-.567 1.267-1.267V7.667C6.067 6.967 5.5 6.4 4.8 6.4Z"
      />
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth={0.857}
        d="M6.067 7.733 7.6 4.267V2.667a.667.667 0 0 1 .667-.667h.066a1.6 1.6 0 0 1 1.534 2.067l-.6 2.066h3.466a1.333 1.333 0 0 1 1.307 1.587l-.667 3.467A1.333 1.333 0 0 1 12.067 12.4H6.067"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgThumbUpFilled);
export default ForwardRef;
